import { Link } from "react-router-dom";
import { User } from "../../../models";
import { useActionState, useEffect } from "react";
import FormBody from "../../../components/form-body";
import Label from "../../../components/label";
import Input from "../../../components/input";
import FormError from "../../../components/form-error";
import { Button } from "../../../components/button";
import { State, updateProfile } from "../actions";
import { useAuth } from "../../../context/AuthContext";

export default function ProfileForm({ user ,reloadProfile }: { user: User , reloadProfile?:()=>void}) {
    
    const auth = useAuth();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: user.name,      
      phone: user.phone,
      address: user.address,
      dob: user.dob,
    },
  };

  const updateProfileWithId = updateProfile.bind(null, user.id || "");
  const [state, formAction, isPending] = useActionState(
    updateProfileWithId,
    initialState
  );

  useEffect(() => {
    if (state.success) {
      if(reloadProfile)
        reloadProfile();
      // Optionally, show a success message or redirect
      // auth.login({...auth.user, ...{
      //   name: state.defaultValues?.name,
      //   phone: state.defaultValues?.phone,
      //   address: state.defaultValues?.address,
      //   dob: state.defaultValues?.dob,
      // } as User});
    }
  }, [state]);

  const fetchUserProfile=async()=>{

  }

  return (
    <form className="space-y-6 max-w-3xl py-8 text-left" action={formAction}>
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            placeholder="Enter name"
            aria-describedby="name-error"
            defaultValue={state.defaultValues?.name ?? ""}
            required
          />
          <FormError id="name-error" message={state.errors?.name} />
        </div>
       

        <div className="mb-4">
          <Label htmlFor="phone">Phone</Label>
          <Input
          readOnly
            id="phone"
            name="phone"
            type="text"
            placeholder="Enter phone number"
            aria-describedby="phone-error"
            defaultValue={state.defaultValues?.phone ?? ""}
          />
          <FormError id="phone-error" message={state.errors?.general} />
        </div>
        <div className="mb-4">
          <Label htmlFor="address">Address</Label>
          <Input
            id="address"
            name="address"
            type="text"
            placeholder="Enter address"
            aria-describedby="address-error"
            defaultValue={state.defaultValues?.address ?? ""}
          />
          <FormError id="address-error" message={state.errors?.general} />
        </div>
        <div className="mb-4">
          <Label htmlFor="dob">Date of Birth</Label>
          <Input
            id="dob"
            name="dob"
            type="date"
            aria-describedby="dob-error"
            defaultValue={
              state.defaultValues?.dob ? state.defaultValues?.dob.split("T")[0] : ""
            }
          />
          <FormError id="dob-error" message={state.errors?.general} />
        </div>
        <div className="mb-4">
          <Label htmlFor="profileImage">Profile Image</Label>
          <Input
            id="profileImage"
            name="profileImage"
            type="file"
            aria-describedby="profileImage-error"
          />
          <FormError id="profileImage-error" message={state.errors?.general} />
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <Button
          type="submit"
          disabled={isPending}
          loading={isPending}
          className="min-w-[90px]"
        >
          Save Changes
        </Button>
      </div>
    </form>
  );
}
